<div class="up-down-buttons-container">
    <div class="arrow" (click)="plusMinus('plus')">
        <i class="pi icon icon-arrow_up_filled icon-size-md cursor-pointer"></i>
    </div>
    <p-divider layout="horizontal"></p-divider>
    <div class="arrow" (click)="plusMinus('minus')">
        <i class="pi icon icon-arrow_down_filled icon-size-md cursor-pointer"></i>
    </div>
</div>
